module.exports = __webpack_public_path__ + "img/review-empty-lg.bb421242.svg";